import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { useRecoilState } from 'recoil'
import { STORAGE_TOKEN_KEY } from '../api/constant'
import { dataARPrivateistState, fetchDataArPrivateList } from '../store'

export default function useFetchDataARPrivateList(setLoading) {
  // const [dataARPayerList, setDataARPayerList] = useRecoilState(dataARPrivateistState)
  const [dataARPayerList, setDataARPayerList] = useState([])

  const history = useHistory()

  useEffect(() => {
    let isApiSubscribed = true
    if (isApiSubscribed) {
      if (!dataARPayerList.length) {
        setLoading(true)
        fetchDataArPrivateList((data, err) => {
          if (data) {
            setDataARPayerList(data)
            setLoading(false)
            if (!data.length) {
              isApiSubscribed = false
            }
          } else {
            if (err.redirect) {
              localStorage.removeItem(STORAGE_TOKEN_KEY)
              history.push('/login')
              setLoading(false)
            }
          }
        })
      }
    }

    return () => {
      // cancel the subscription
      isApiSubscribed = false
    }
  }, [dataARPayerList.length, setDataARPayerList, setLoading, history])

  return { dataARPayerList }
}
